import React, { useContext } from "react";
import classes from "./Layout.module.scss";
import MainNav from "../Navs/MainNav";
import ScrollToTop from "../../components/ScrollToTop";
import WaterMarkProbrain from "../../components/WaterMarkProbrain";
import UserTrainingContext from "../../context/userTrainingContext";
import Footer from "../../components/Footer";
import SessionContext from "../../context/sessionContext";
import Dashboard from "../../components/Dashboard/index";
import HeaderUserGo from "../../containers/User/Home/HeaderUserGo";
import { useLocation, useNavigate } from "react-router";
import IconBrainHeader from "../../assets/images/usersGo/brainHeader.svg";
import * as r from "../../constants/routes";
import { useTranslation } from "react-i18next";
interface Interface {
  children?: any;
  style?: {
    [propName: string]: any;
  };
  className?: string | null;
}
export default function Layout({
  children,
  style = {},
  className = "",
}: Interface) {
  const tContext = useContext(UserTrainingContext);
  const cSession = useContext(SessionContext);
  const { t } = useTranslation();
  const history = useNavigate();

  const location = useLocation();

  const isTrainingPage = location.pathname.includes("/treinamento");

  // Obtém o slug da categoria pela URL
  const categorySlug = location.pathname.split("/")[2];

  const categoryName = categorySlug
    ?.replaceAll("-", " ")
    ?.replace(/\b\w/g, (item) => item.toUpperCase())
    ?.replace("Memoria", "Memória");

  // Obtém o registro (nome) do usuário GO
  const goUserName = cSession?.user?.registry;

  // Exibe o header apenas para usuários comuns (não Smart)
  const showHeader = cSession.is_user && !cSession.is_smart_user;

  const showTrainingHeader = showHeader && isTrainingPage;
  const showHomeHeader = showHeader && !isTrainingPage;

  return (
    <div className={className + " " + classes.Layout}>
      <MainNav />
      {/* Header do smart */}
      {cSession.is_smart_user && <Dashboard />}

      {/* Header do GO */}
      {showTrainingHeader && (
        <HeaderUserGo
          name={categoryName}
          text={t("global.train_for_at_least_2_games_a_day")}
          icon={<img src={IconBrainHeader} />}
          buttonText={"Voltar"}
          onClick={() => history(r.R_U_WELCOME)}
        />
      )}
      {showHomeHeader && (
        <HeaderUserGo
          name={`Olá, ${goUserName}`}
          text={t(
            "global.choose_which_of_the_categories_you_want_to_train_today",
          )}
        />
      )}

      {/* <LoginBanner /> */}
      <div className={classes.InnerArea}>{children}</div>
      {cSession.is_session_active && <Footer />}
      <WaterMarkProbrain />
      <ScrollToTop />
    </div>
  );
}
